import { stepsPrefixCls } from "@/base/components/index";
import { createStyles } from "antd-style";

export const useLayoutOnboardingSectionStyles = createStyles(
  ({ token, css }: any) => ({
    root: css`
      .${stepsPrefixCls} {
        max-width: 716px;
      }

      ul {
        padding-left: 16px;
        margin: 0;
        margin-top: 12px;

        li {
          padding-block: 2px;
          &::marker {
            color: ${token.ColorFigmaProductaccentAccent0150};
            font-size: 16px;
          }
        }
      }
    `,
  }),
);
